// Campaign window, not a claim that the Shopify automatic discount expires.
// Merchant confirmed daily tests renewed at the visitor's local midnight.
(() => {
  function remaining(now){const next=new Date(now);next.setHours(24,0,0,0);return Math.max(0,Math.ceil((next-now)/1000));}
  function tick(){const seconds=remaining(new Date());const label=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n=>String(n).padStart(2,'0')).join(':');document.querySelectorAll('[data-launch-clock]').forEach(el=>{el.textContent=label;el.setAttribute('aria-label',label+' until the next daily launch test');});}
  tick();setInterval(tick,1000);document.addEventListener('visibilitychange',tick);document.addEventListener('shopify:section:load',tick);
})();

// Safari may chain a sideways one-finger gesture from overflowing content to
// the document. Keep that gesture in real horizontal scrollers, never the page.
(() => {
  let origin=null;
  const normalScale=()=>!window.visualViewport||window.visualViewport.scale<=1.02;
  const active=()=>window.matchMedia('(max-width: 989px)').matches&&normalScale();
  document.addEventListener('touchstart',event=>{
    if(!active()||event.touches.length!==1){origin=null;return;}
    const touch=event.touches[0];origin={x:touch.clientX,y:touch.clientY,target:event.target,axis:null};
  },{passive:true});
  document.addEventListener('touchmove',event=>{
    if(!origin||event.touches.length!==1||!active())return;
    const dx=event.touches[0].clientX-origin.x,dy=event.touches[0].clientY-origin.y;
    if(!origin.axis&&Math.max(Math.abs(dx),Math.abs(dy))>7)origin.axis=Math.abs(dx)>Math.abs(dy)?'x':'y';
    if(origin.axis!=='x')return;
    // Find a scrollable ancestor that can consume this direction. At its edge,
    // prevent the gesture from escaping into the document's white outside area.
    for(let el=origin.target instanceof Element?origin.target:origin.target.parentElement;el&&el!==document.body&&el!==document.documentElement;el=el.parentElement){
      const style=getComputedStyle(el);
      if(/auto|scroll/.test(style.overflowX)&&el.scrollWidth>el.clientWidth+1){
        const max=el.scrollWidth-el.clientWidth;
        if((dx<0&&el.scrollLeft<max-1)||(dx>0&&el.scrollLeft>1))return;
      }
    }
    if(event.cancelable)event.preventDefault();
  },{passive:false});
  const reset=()=>{origin=null};
  document.addEventListener('touchend',reset,{passive:true});
  document.addEventListener('touchcancel',reset,{passive:true});
})();